import { Fragment, useEffect, useState } from 'react';
import ModuleLayout from './ModuleLayout';
import { updateOrCreate } from '../special/updateOrCreate';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { API_DELETE, API_PATCH, DBRequest, useConfig } from '../../api/api';
import {
  Badge,
  Box,
  Button,
  Collapse,
  IconButton,
  Typography,
  useTheme,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { TaskContent } from '../exo/project/work-package-elements/WPEToDoElement';
import useFetch from '../../api/useFetch';
import { tokens } from '../../global/theme/tokens';
import { NavLink } from 'react-router-dom';
import DeleteIcon from '@mui/icons-material/Delete';

const DashboardAllTodos = ({ colSpan, rowSpan, debug }) => {
  const config = useConfig();
  const { apiData, setApiData } = useFetch('modules/open-tasks');
  const [isProcessing, setIsProcessing] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const { t } = useTranslation();

  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);

  function handleChangedElement(changedElement) {
    const newTasks = updateOrCreate(apiData, changedElement.data);
    setApiData(newTasks);
  }

  function onDelete(element) {
    const dbTasks = apiData.data.filter((obj) => obj.id !== element.id);
    setApiData({ ...apiData, data: dbTasks });
  }
  function handleDelete(element) {
    DBRequest({
      config,
      path: `work-packages/elements/list/tasks/${element.id}`,
      method: API_DELETE,
      onResponse: () => onDelete(element),
      onLoading: setIsLoading,
    });
  }

  const priorityColorMap = {
    0: colors.grey,
    1: colors.success,
    2: colors.warning,
    3: colors.error,
  };

  function handleToggleComplete(e) {
    if (isProcessing) return;
    e.status ? (e.status = 0) : (e.status = 1);
    console.log(e);

    DBRequest({
      config,
      path: `work-packages/elements/list/tasks/${e.id}`,
      method: API_PATCH(e),
      onResponse: handleChangedElement,
      onLoading: setIsProcessing,
    });
  }

  function handleStatusChange(e) {
    e.priority = (e.priority + 1) % 4;
    console.log(e, 'After Priority Changed');
    DBRequest({
      config,
      path: `work-packages/elements/list/tasks/${e.id}`,
      method: API_PATCH(e),
      onResponse: handleChangedElement,
    });
  }

  // console.log('API DATA', apiData);

  return (
    <ModuleLayout
      colSpan={colSpan}
      rowSpan={rowSpan}
      isLoading={!apiData || isLoading}
      label={t('Project Tasks')}
    >
      <Box className="h-full overflow-auto p-2">
        {apiData ? (
          apiData.data?.map((el, index) => (
            <Box
              className="relative flex w-full gap-1 overflow-hidden"
              key={el.id}
              sx={{
                '.del-button': {
                  width: '0px',
                  transition: '0.3s ease',
                },
                '.to-project-button': {
                  width: '0px',
                  transition: '0.3s ease',
                },
                ':hover': {
                  '.del-button': {
                    width: '30px',
                  },
                  '.to-project-button': {
                    width: '50px',
                  },
                },
              }}
            >
              <TaskContent
                key={el.id}
                className="w-full"
                element={el}
                onDelete={() => {}}
                priorityColorMap={priorityColorMap}
                onToggleComplete={() => handleToggleComplete(el)}
                isProcessing={isProcessing}
                openPopup={openPopup === el.id}
                setOpenPopup={(bool) => setOpenPopup(bool ? el.id : null)}
                handleResponse={handleChangedElement}
                handleStatusChange={() => handleStatusChange(el)}
                wpeId={el.workPackageId}
                pid={el.projectId}
              />
              <NavLink
                to={`/projects/management/${el.projectId}/work-package/${el.workPackageId}`}
                className="to-project-button overflow-hidden"
              >
                <Button
                  sx={{
                    padding: '0px',
                    minWidth: '0px',
                    border: `1px solid transparent`,
                    ':hover': {
                      bgcolor: colors.info + 30,
                      border: `1px solid ${colors.info}80`,
                    },
                  }}
                  className=" h-full w-full"
                >
                  <OpenInNewIcon sx={{ fontSize: 18 }} />
                </Button>
              </NavLink>
              <Box className="del-button overflow-hidden">
                <Button
                  onClick={() => handleDelete(el)}
                  sx={{
                    padding: '0px',
                    minWidth: '0px',
                    border: `1px solid transparent`,
                    border: `1px solid transparent`,
                    ':hover': {
                      bgcolor: colors.error + 30,
                      border: `1px solid ${colors.error}80`,
                    },
                  }}
                  className="h-full w-full"
                >
                  <DeleteIcon sx={{ fontSize: 18 }} color="error" />
                </Button>
              </Box>
            </Box>
          ))
        ) : (
          <Box className="h-full flex justify-center items-center">
            <Typography>{t('No Tasks found')}</Typography>
          </Box>
        )}
      </Box>
    </ModuleLayout>
  );
};

export default DashboardAllTodos;
